import React, { Component } from "react";
import { BiGlobe } from "react-icons/bi";
import { receivedAt } from "../../../../utils/dateTime.utils";
import { POST_INTERACTIONS } from "../../../../utils/Images.utils";
import { profile } from "../../../../utils/localstorage.utils";
import Image from "../../../common/Image";
import PostComments from "./PostComments";
import { MdOutlineArrowForwardIos, MdOutlineLock } from "react-icons/md";
import DenPoll from "./DenPoll";
import { Carousel, Modal } from "react-bootstrap";
import { BsThreeDots } from "react-icons/bs";
import Sparks from "./Sparks";
import {
  createAndShareDenPost,
  getDenProfilePicture,
  updateDenProfileInLocalStorage,
} from "../../../../utils/Den.utils";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import RePostCard from "./RePostCard";
import { DEN } from "../../../../utils/Strings.utils";
import Interactions from "./Interactions.js";
import PrivatePost from "./PrivatePost";
import { STYLE } from "../../../../utils/Style.utils";
import ReactPlayer from "react-player";
import LiveChat from "./LiveChat";
import UndoReportPost from "../../../common/UndoReportPost";
import { getNumberFormat } from "../../../../utils/Numbers.utils";
import DenInteractions from "../../../popup/den/DenInteractions";

export default class PostCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      post: props.post,
      i: props.i,
      denProfile: props.denProfile,
      interactions: props.interactions,
      feedDetails: props.feedDetails,
      selectedPostIndex: null,
      postToInteract: null,
      showInteractions: false,
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      post: newProps.post,
      i: newProps.i,
      denProfile: newProps.denProfile,
      interactions: newProps.interactions,
      feedDetails: newProps.feedDetails,
    });
  }

  updateState = (key, val) => {
    this.setState({ [key]: val });
  };

  updateProfileDetails = updatedProfileDetails => {
    this.showHidePostAction(null, false, false);
    this.setState({
      denProfile: updatedProfileDetails,
    });
    this.props.updateProfileDetails(updatedProfileDetails);
    //updateDenProfileInLocalStorage(updatedProfileDetails);
  };

  updatePostDetails = (result, selectedActionIndex, message) => {
    if (message) {
      toast.success(message);
    }
    const updatedPostDetails = this.state.feedDetails.map((post, i) => {
      if (post.type === "REPOST") {
        if (post.rePostDetails[0]._id === result._id) {
          post.rePostDetails[0].assets = result.assets;
          post.rePostDetails[0].description = result.description;
          return post;
        }
      } else {
        if (post._id === result._id) {
          result.from = this.state.feedDetails[i].from;
          return result;
        } else {
          return post;
        }
      }
    });
    this.props.updatePostDetails(result);
    this.setState({
      feedDetails: updatedPostDetails,
    });
    this.showHidePostAction(null, false, false);
  };

  showHidePostAction = (index, val1, val2) => {
    this.props.showHidePostAction(index, val1, val2);
    if (!val1 && !val2) {
      this.setState({
        selectedActionIndex: null,
        selectedReportType: null,
        selectedReportTypeDescription: null,
        openPostActionModal: val1,
        openPostReportModal: val2,
      });
    } else {
      this.setState({
        selectedActionIndex: index,
        openPostActionModal: val1,
        openPostReportModal: val2,
      });
    }
  };

  updateLikedPostDetails = result => {
    var updatedFeedDetails = this.state.feedDetails;
    updatedFeedDetails[this.state.selectedPostIndex].likes = result.likes;
    this.setState({
      feedDetails: updatedFeedDetails,
      selectedPostIndex: null,
    });
  };

  getFilterredDescription = description => {
    var array = description.split(" ");

    return (
      <div>
        {array.map((text, i) => {
          if (text.includes("#")) {
            return (
              <b key={i} className='has-tag text-white"'>
                {" "}
                {text}
              </b>
            );
          } else {
            return (
              <span key={i} className="fs-12 fw-400 text-white">
                {" "}
                {text}
              </span>
            );
          }
        })}
      </div>
    );
  };

  shareDenPost = postId => {
    var data = {
      postAs: "USER",
      type: "REPOST",
      rePostId: postId,
      description: "", //this.state.description,
      assets: [], //this.state.images
      denId: this.state.denProfile?._id,
    };
    createAndShareDenPost(data, this.denPostShared, true);
  };

  denPostShared = (result, isShare) => {
    toast.success(`You post has been successfully ${isShare ? "shared" : "drafted"} !`);
    this.props.updatePostDetails(result.postDetails);
    this.updateProfileDetails(result.profileDetails);
    //updateDenProfileInLocalStorage(result.profileDetails);
    //this.props.history.push('/den')
  };

  goToUserDenProfile = profileId => {
    const { post } = this.state;
    let userDenProfile = post.from[0];
    if (userDenProfile.isDeleted || !userDenProfile.isActive) {
      toast.error(`This user's den profile is currently deactivated`);
      return false;
    }
    this.props.history.push(`/den/${this.state.denProfile?._id}/profile-page/${profileId}`);
  };

  jumpToLiveStream = (e, postId) => {
    e.preventDefault();
    this.props.history.push(`/den/${this.state.denProfile?._id}/live-streaming/${postId}`);
  };

  checkStatus = e => {
    if (this.props.checkDenStatus) {
      e.preventDefault();
    }
  };

  render() {
    const {
      i,
      post,
      interactions,
      denProfile,
      feedDetails,
      postToInteract,
      reportedPostId,
      showInteractions,
    } = this.state;

    var sparkDetails = {
      logo: [],
      likes: 0,
      users: [],
    };

    Object.keys(post.likes).map((key, i) => {
      sparkDetails.likes += post.likes[key].length;
      sparkDetails.users = sparkDetails.users.concat(post.likes[key]);
      if (post.likes[key].length > 0) {
        sparkDetails.logo.push(key);
      }
    });

    const openCommentSection =
      this.state.postToInteract !== null && this.state.postToInteract === i;

    if (post.rePostId) {
      return (
        <RePostCard
          key={i}
          sparkDetails={sparkDetails}
          selectedPostIndex={this.state.selectedPostIndex}
          updatePostDetails={this.updatePostDetails}
          updateState={this.updateState}
          post={post}
          denProfile={denProfile}
          feedDetails={feedDetails}
          i={i}
          showHidePostAction={this.showHidePostAction}
          postToInteract={postToInteract}
          interactions={interactions}
          showMoreNotificationIndex={this.state.showMoreNotificationIndex}
          getFilterredDescription={this.getFilterredDescription}
          updateLikedPostDetails={this.updateLikedPostDetails}
          denPostShared={this.denPostShared}
          goToUserDenProfile={this.goToUserDenProfile}
          updateProfileDetails={this.updateProfileDetails}
          reportedPostId={reportedPostId}
          checkDenStatus={this.props.checkDenStatus}
        />
      );
    } else {
      var profilePicture = getDenProfilePicture(post.from[0]);
      return (
        <div className="col-12 pt-2" key={i}>
          {this.props.isPrivatePost ? (
            <PrivatePost
              post={post}
              getFilterredDescription={this.getFilterredDescription}
              interactions={interactions}
              profilePicture={profilePicture}
              sparkDetails={sparkDetails}
              goToUserDenProfile={this.goToUserDenProfile}
              checkDenStatus={this.props.checkDenStatus}
            />
          ) : (
            <div className="steel_gray-card">
              <div className="row px-3 pt-3">
                <div className="col-12">
                  <div className="d-flex">
                    <div
                      onClick={() => this.goToUserDenProfile(post.from[0]?._id)}
                      className="d-flex flex-grow-1 cursor-pointer"
                    >
                      <Image
                        src={profilePicture?.url}
                        param={post.from[0]?.name ? post.from[0]?.name : "Test"}
                        className="rounded-circle btn-size-32 border-1"
                        alt="owner-avatar"
                      />
                      <div className="ms-2 flex-grow-1">
                        <h1 className="fs-14 fw-600 text-white mb-0">
                          {post.from[0]?.name ? post.from[0]?.name : null}{" "}
                          <span style={STYLE.FONT.WEIGHT.W300}>
                            {POST_INTERACTIONS.FEELINGS[post.feeling]
                              ? `is feeling ${POST_INTERACTIONS.FEELINGS[post.feeling].NAME}`
                              : post.feeling}
                          </span>{" "}
                          {POST_INTERACTIONS.FEELINGS[post.feeling] && (
                            <img
                              src={POST_INTERACTIONS.FEELINGS[post.feeling]?.LOGO}
                              alt=""
                              style={STYLE.FONT.HEIGHT.H18}
                            />
                          )}{" "}
                        </h1>

                        {/* <p className='fs-12 text-white-50 fw-bold opacity-25'>{receivedAt(post.createdAt)} ago<span className='me-1'>. { post.updatedAt !== post.createdAt &&`(Edited)`} </span> */}
                        <p className="fs-12 text-white-50 fw-bold opacity-25">
                          {receivedAt(post.createdAt)} ago<span className="me-1">. </span>
                          {post.from[0]?.isPublic ? (
                            <BiGlobe className="text-white btn-size-12" />
                          ) : (
                            <MdOutlineLock className="text-white btn-size-12" />
                          )}
                        </p>
                      </div>
                    </div>

                    {this.props.postType === DEN.POST_TYPES.DRAFT ? (
                      <NavLink
                        className="post-action ms-auto"
                        to={`/den/${denProfile?._id}/create-post/${post._id}`}
                      >
                        <MdOutlineArrowForwardIos className="post-action ms-auto" />
                      </NavLink>
                    ) : (
                      // <BsThreeDots className="post-action ms-auto" onClick={() => this.showHidePostAction(i,true, false)} />
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          if (this.props.checkDenStatus()) {
                            this.showHidePostAction(i, true, false);
                          }
                        }}
                      >
                        <Image
                          src={POST_INTERACTIONS.ACTIONS.MORE}
                          params={"action"}
                          className=""
                          style={STYLE.AREA.WIDTH.W24}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-12 my-1">
                  {post.description && (
                    <>
                      {(this.state.showMoreNotificationIndex !== null &&
                        this.state.showMoreNotificationIndex === i) ||
                      post.description.length < 251 ? (
                        <span className="fs-12 fw-400 text-white" style={STYLE.FONT.SPACE}>
                          {this.getFilterredDescription(post.description)}
                        </span>
                      ) : (
                        <span className="fs-12 fw-400 text-white" style={STYLE.FONT.SPACE}>
                          <em>
                            {this.getFilterredDescription(
                              post.description.slice(0, 250 - post.description.length)
                            )}
                            ...
                          </em>
                          <a
                            className="fs-14 fw-bold cursor-pointer den-show-more"
                            onClick={() => this.updateState("showMoreNotificationIndex", i)}
                          >
                            Show More
                          </a>
                        </span>
                      )}
                    </>
                  )}
                </div>
              </div>

              {post.type && post.type === "TV" ? (
                <NavLink
                  to={`/den/${this.state.denProfile?._id}/live-streaming/${post._id}`}
                  className="d-flex flex-column align-items-center den-assets cursor-pointer nawaz2"
                  onClick={e => this.jumpToLiveStream(e, post._id)}
                >
                  <div
                    className="cursor-pointer"
                    style={STYLE.DEN.POST.FULL_WIDTH}
                    onClick={e => this.jumpToLiveStream(e, post._id)}
                  >
                    <ReactPlayer
                      className="cursor-pointer"
                      url={post?.assets[0]?.url}
                      width="100%"
                      playing={false}
                      height="210px"
                      onClick={e => this.jumpToLiveStream(e, post._id)}
                    />
                    {this.state.selectedPostIndex !== null && (
                      <Sparks
                        denProfile={this.state.denProfile}
                        index={i}
                        feedDetails={feedDetails}
                        selectedPostIndex={this.state.selectedPostIndex}
                        updateLikedPostDetails={this.updateLikedPostDetails}
                        updateProfileDetails={this.updateProfileDetails}
                      />
                    )}
                  </div>
                </NavLink>
              ) : (
                <div className="d-flex flex-column align-items-center den-assets">
                  {post.type && post.type === "POST" ? (
                    <Carousel
                      interval={null}
                      className={`${post.assets.length > 1 ? "" : "single"}`}
                    >
                      {post.assets.map((asset, i) => {
                        return (
                          <Carousel.Item key={i} className="">
                            {asset.type.includes("video") ? (
                              <video
                                width="320"
                                height="240"
                                className="feed_post-image"
                                controls
                                autoPlay={false}
                              >
                                <source src={asset.url} type="video/mp4" />
                                Your browser does not support the video tag.
                              </video>
                            ) : (
                              <img
                                src={asset.url}
                                className="feed_post-image"
                                alt=""
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src =
                                    "https://espotz-webapp-images.s3.ap-south-1.amazonaws.com/assets/broken-1.png";
                                }}
                              />
                            )}
                          </Carousel.Item>
                        );
                      })}
                    </Carousel>
                  ) : (
                    <DenPoll
                      updateState={() => {}}
                      post={post}
                      denProfile={this.state.denProfile}
                      updatePostDetails={this.updatePostDetails}
                      enableEdit={false}
                    />
                  )}

                  {/* Grid of spark's on a post */}
                  {this.state.selectedPostIndex !== null && (
                    <Sparks
                      denProfile={this.state.denProfile}
                      index={i}
                      feedDetails={feedDetails}
                      selectedPostIndex={this.state.selectedPostIndex}
                      updateLikedPostDetails={this.updateLikedPostDetails}
                      updateProfileDetails={this.updateProfileDetails}
                    />
                  )}
                </div>
              )}

              <div className="d-flex px-2 py-2">
                {/* <NavLink to={`/den/${this.state.denProfile?._id}/feed/post/${post._id}`} className={`${sparkDetails?.logo?.length ? 'd-flex align-items-center cursor-pointer' : 'd-none'}`}>
                                    {sparkDetails?.logo.map((key,k)=>{
                                        return  <img key={k} src={POST_INTERACTIONS.SPARKS[key.toUpperCase()].LOGO} alt='' className='rounded-circle' style={(k === sparkDetails?.logo.length-1) ? { height:'16px', width:'16px' , marginLeft:'-5px'} : { height:'16px', width:'16px' , marginLeft:'-5px'}} />
                                    })}
                                    <span className='fs-14 fw-600 text-white-50 ms-2 my-0'>{sparkDetails?.likes > 0 ? getNumberFormat(sparkDetails?.likes) : null}</span>
                                </NavLink> */}
                <div
                  onClick={() =>
                    this.props.checkDenStatus() ? this.setState({ showInteractions: true }) : null
                  }
                  className={`${sparkDetails?.logo?.length ? "d-flex align-items-center cursor-pointer" : "d-none"}`}
                >
                  {sparkDetails?.logo.map((key, k) => {
                    return (
                      <img
                        key={k}
                        src={POST_INTERACTIONS.SPARKS[key.toUpperCase()].LOGO}
                        alt=""
                        className="rounded-circle"
                        style={
                          k === sparkDetails?.logo.length - 1
                            ? { height: "16px", width: "16px", marginLeft: "-5px" }
                            : { height: "16px", width: "16px", marginLeft: "-5px" }
                        }
                      />
                    );
                  })}
                  <span className="fs-14 fw-600 text-white-50 ms-2 my-0">
                    {sparkDetails?.likes > 0 ? getNumberFormat(sparkDetails?.likes) : null}
                  </span>
                </div>
                <div className="d-flex align-items-center mx-2 flex-grow-1"></div>
                <div className="d-flex align-items-center mx-2">
                  <img
                    src={POST_INTERACTIONS.HAMMER.OFF}
                    alt=""
                    style={STYLE.DEN.POST.INTERACTIONS}
                  />
                  <span className="fs-14 fw-600 text-white-50 ms-2 my-0">{post.hammer.length}</span>
                </div>
                <div className="d-flex align-items-center mx-2">
                  <img
                    src={POST_INTERACTIONS.SHARE.OFF}
                    alt=""
                    style={STYLE.DEN.POST.INTERACTIONS}
                  />
                  <span className="fs-14 fw-600 text-white-50 ms-2 my-0">{post.shares.length}</span>
                </div>
              </div>
              <hr className="my-1" style={STYLE.DEN.POST.LINE} />

              <Interactions
                index={i}
                interactions={interactions}
                styleLogo={STYLE.DEN.POST_STYLE}
                openCommentSection={openCommentSection}
                post={post}
                selectedPostIndex={this.state.selectedPostIndex}
                postToInteract={this.state.postToInteract}
                denProfile={denProfile}
                updateState={this.updateState}
                shareDenPost={this.shareDenPost}
                isLiveStraming={this.props.isLiveStraming}
                history={this.props.history}
              />

              {openCommentSection ? (
                <PostComments
                  denProfile={denProfile}
                  updateProfileDetails={this.updateProfileDetails}
                  postDetails={post}
                  feedDetails={feedDetails}
                  postId={post._id}
                />
              ) : null}
              {this.props.showLiveComments ? (
                <LiveChat
                  denProfile={denProfile}
                  updateProfileDetails={this.updateProfileDetails}
                  postDetails={post}
                  feedDetails={feedDetails}
                  postId={post._id}
                />
              ) : null}

              {showInteractions && (
                <Modal show={showInteractions} centered dialogClassName="transaction-details-modal">
                  <Modal.Body>
                    <DenInteractions
                      denId={this.state.denProfile?._id}
                      id={post._id}
                      type="post"
                      close={() => this.setState({ showInteractions: false })}
                    />
                  </Modal.Body>
                </Modal>
              )}
            </div>
          )}
          {reportedPostId === post._id && <UndoReportPost reportedPostId={reportedPostId} />}
        </div>
      );
    }
  }
}
